module.exports = __webpack_public_path__ + "img/favoris-icon-white-empty.9e510fc1.svg";